/**
 * Express Integration Utility
 * Handles communication and visibility between GAQ and Express Redbox
 */

/**
 * Show the Express container if it exists
 */
export const showExpressContainer = () => {
  const expressContainer = document.getElementById("mydhlplus-mvp-guest-flow");
  if (expressContainer) {
    expressContainer.style.display = "block";
  }
};

/**
 * Hide the Express container
 */
export const hideExpressContainer = () => {
  const expressContainer = document.getElementById("mydhlplus-mvp-guest-flow");
  if (expressContainer) {
    expressContainer.style.display = "none";
  }
};

/**
 * Show the GAQ content container
 */
export const showGaqContent = () => {
  const gaqContent = document.querySelector(".dhl-cj-main.dhl-cj-ots");
  if (gaqContent) {
    gaqContent.style.display = "block";
  }
};

/**
 * Hide the GAQ content container
 */
export const hideGaqContent = () => {
  const gaqContent = document.querySelector(".dhl-cj-main.dhl-cj-ots");
  if (gaqContent) {
    gaqContent.style.display = "none";
  }
};

/**
 * Send data to Express via BroadcastChannel API
 */
export const sendDataToExpress = (data) => {
  if ("BroadcastChannel" in window) {
    try {
      const gaqToExpressChannel = new BroadcastChannel("gaq-to-express");
      const message = {
        type: "GAQ_DATA",
        data,
      };
      gaqToExpressChannel.postMessage(message);
    } catch (error) {
      // Silent fail - Express integration is optional
    }
  }
};

/**
 * Load and initialize Express container with data
 * Optionally merges package type data from shipment lane
 */
export const loadExpress = (expressData, packageType) => {
  // Merge package type if provided, overriding the backend's hardcoded type
  const mergedData = packageType
    ? { ...expressData, type: packageType.toUpperCase() }
    : expressData;

  showExpressContainer();
  hideGaqContent();
  sendDataToExpress(mergedData);
};

/**
 * Initialize Express prevention logic on app startup
 * Handles visibility of Express vs GAQ based on URL parameters
 */
export const initializeExpressHandling = () => {
  const urlParams = new URLSearchParams(window.location.href);
  const hasShipmentId = urlParams.has("shipmentId");

  const handleContainerVisibility = () => {
    if (hasShipmentId) {
      showExpressContainer();
      hideGaqContent();
    } else {
      hideExpressContainer();
      showGaqContent();
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", handleContainerVisibility);
  } else {
    handleContainerVisibility();
  }
};
